import { type ModalKeys } from "@/lib/store/modal";
import { ModalAppExplainer } from "./app/explainer";
import { ModalPushNotificationsDenied } from "./app/push-notifications-denied";

export function ModalProvider() {
  return (
    <>
      {Object.entries({
        appExplainer: ModalAppExplainer,
        pushNotificationsDenied: ModalPushNotificationsDenied,
      } satisfies Record<ModalKeys, () => JSX.Element>).map(([key, Component]) => (
        <Component key={key} />
      ))}
    </>
  );
}
